import {useCurrencies} from '~/api/deimos/currencies'
import {useLoggedInUser} from '~/shell/user'

import {useWalletCurrency} from './use-wallet-currency'

export const useTransferDetails = () => {
    const currency = useWalletCurrency()
    const {companyId} = useLoggedInUser()
    const {data: currencies} = useCurrencies(companyId)

    return (currencies || []).find((details) => {
        return details.currency === currency
    })
}
